import "../App.css";
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

function PrintsPage() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [orientation, setOrientation] = useState("portrait");

  useEffect(() => {
    async function fetchProducts() {
      try {
        const response = await fetch(`${API_BASE_URL}/products`);
        const data = await response.json();
        console.log(data);
        // Group products by name
        const groupedProducts = data.reduce((groups, product) => {
          if (!groups[product.name]) {
            groups[product.name] = [];
          }
          groups[product.name].push(product);
          return groups;
        }, {});

        // Extract only the first product for display
        const uniqueProducts = Object.values(groupedProducts).map(
          (productsGroup) => ({
            baseProduct: productsGroup[0],
            variations: productsGroup,
          })
        );

        setProducts(uniqueProducts);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching products:", error);
        setLoading(false);
      }
    }

    fetchProducts();
  }, []);

  const filteredProducts = products
    .filter((productGroup) =>
      orientation === "landscape"
        ? productGroup.baseProduct.metadata.orientation === "landscape"
        : productGroup.baseProduct.metadata.orientation === "portrait"
    )
    .sort(
      (a, b) => a.baseProduct.metadata.order - b.baseProduct.metadata.order
    );

  return (
    <div className="PrintsPage">
      {/* Toggle Button */}
      <div className="toggle-button-container">
        <button
          className={`toggle-button ${
            orientation === "landscape" ? "active" : ""
          }`}
          onClick={() => setOrientation("landscape")}
        >
          Landscape
        </button>
        <button
          className={`toggle-button ${
            orientation === "portrait" ? "active" : ""
          }`}
          onClick={() => setOrientation("portrait")}
        >
          Portrait
        </button>
      </div>

      <div
        className={
          orientation === "landscape"
            ? "landscape-prints-grid"
            : "portrait-prints-grid"
        }
      >
        {loading ? <p>Loading Prints...</p> : <></>}

        {filteredProducts.map((productGroup, index) => (
          <Link
            key={index}
            to={`/prints/${productGroup.baseProduct.name}`}
            state={{ productGroup }}
          >
            <ProductCard
              baseProduct={productGroup.baseProduct}
              variations={productGroup.variations}
            />
          </Link>
        ))}
      </div>
    </div>
  );
}

export default PrintsPage;

function ProductCard({ baseProduct, variations }) {
  const [selectedVariation, setSelectedVariation] = useState(
    baseProduct.metadata?.variation || "default"
  );
  // const [selectedSize, setSelectedSize] = useState("A3");
  // const [quantity, setQuantity] = useState(1);

  // Find the selected product for the variation
  const selectedProduct =
    variations.find(
      (product) => product.metadata.variation === selectedVariation
    ) || baseProduct;

  return (
    <div className="print-item">
      <img
        src={selectedProduct.images[0]}
        alt={selectedProduct.name}
        className={
          selectedProduct.metadata.orientation === "landscape"
            ? "landscape-print-image"
            : "portrait-print-image"
        }
      />
      <h3 className="printName text-lowercase ">{selectedProduct.name}</h3>
    </div>
  );
}
